module.exports = __webpack_public_path__ + "static/media/inkHair.6da90575.jpg";